import React from 'react'
import FooterApi from 'utils/FooterApi'
import BreadcrumbComponent from 'components/Breadcrumbs'
import { MainWrapper, AboutUsWrapper, ContentWrapper } from 'styles/FooterLinks/AboutUsPage'

const CancellationPolicy = () => {
  const { data } = FooterApi('cancelpolicy')
  return (
    <MainWrapper>
      <AboutUsWrapper>
        <BreadcrumbComponent title="Cancellation Policy" />
        <ContentWrapper>
          <div dangerouslySetInnerHTML={{ __html: data?.cancelpolicy }} />
        </ContentWrapper>
      </AboutUsWrapper>
    </MainWrapper>
  )
}

export default CancellationPolicy
